import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL



export function getGraficaDataIn(SuscriptionId:String, CloudAccountId:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/historicalForOperation')
  }

export function getDataConnector(SuscriptionId:Number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?source='+source)
  }

export function getDataConnectorGlobal(SuscriptionId:Number,tenant:number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?tenantId='+tenant+'&source='+source)
  }

export function getCTXRStatus (SuscriptionId:Number,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr',{params:{cloud,region}})
  }

export function getCTXRStatusGlobal (SuscriptionId:Number,tenant:number,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr?tenantId='+tenant, {params:{cloud,region}} )
  }

export function getCTXRstatus (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr')
  }

export function getCTXRstatusGlobal (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr?tenantId='+tenant )
  }


export function getInstances (SuscriptionId:Number, source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?source='+source)
  }

export function getInstancesGlobales (SuscriptionId:Number,tenant:number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?tenantId='+tenant+'&source='+source)
  }

export function getStatusSesiones (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary')
  }
export function getStatusSesionesglobales (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary?tenantId='+tenant)
  }
//////////////////////////
export function getCTXNeighborstatus (SuscriptionId:Number,signal:any,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor/',{signal:signal,params:{cloud,region}});
  }
  
export function getCTXNeighborstatusGlobal (SuscriptionId:Number, tenant:number,signal:any,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor?tenantId='+tenant,{signal:signal,params:{cloud,region}});
  }

export function getCTXNeighborstatusG (SuscriptionId:Number,signal:any) {
  return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor/',signal);
}
  
export function getCTXNeighborstatusGlobalG (SuscriptionId:Number, tenant:number,signal:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor?tenantId='+tenant,signal);
}
///////////////////////////////
export function getCloudStatus (SuscriptionId:Number,type?:String,region?:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth',{params:{type,region}})
  }

export function getCloudStatusGlobal (SuscriptionId:Number,tenantId?:number,type?:String,region?:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth',{params:{type,region,tenantId}})
  }

export function getCloudsStatus (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth')
  }

export function getCloudsStatusG (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?tenantId='+tenant)
  }

export function getTopology (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/topology')
  }

export function getsuscription () {
    return axios.get(API_URL+'/v1/suscription')
  }

export function getsuscriptionglobal (tenant:number) {
    return axios.get(API_URL+'/v1/suscription?tenantId='+tenant)
  }

  
export function getConnectors(SuscriptionId:number) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/connector')
}

export function getCTXRlist(SuscriptionId:number) {
  return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/listSelector')
}

export function getCTXRlistGlobal(SuscriptionId:number,tenant:number) {
  return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/listSelector?tenantId='+tenant)
}
